import { gql } from "@apollo/client";

export const carListQuery = gql`
  query carList {
    carList {
      id
      model
      color
      year
      price
    }
  }
`;

export const updateCarMutation = gql`
  mutation updateCar($input: UpdateCarInput!) {
    updateCar(input: $input) {
      id
      model
      color
      year
      price
    }
  }
`;

export const createCarMutation = gql`
  mutation createCar($input: CreateCarInput!) {
    createCar(input: $input) {
      id
      model
      color
      year
      price
    }
  }
`;

export const deleteCarMutation = gql`
  mutation deleteCarMutation($input: DeleteCarInput!) {
    deleteCar(input: $input) {
      id
      model
      color
      year
      price
    }
  }
`;
